module.exports = __webpack_public_path__ + "add3a1e9b24f39e0d22f723c320df71b.png";